import {
  Box,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  TextField,
  Tooltip,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import {
  IFiles,
  IFuid,
  IDocumentsFuid,
  IDocsExpedientsSend,
} from "../../../redux/types/types";
import { useStyles } from "../../../shared/styles/useStyles";
import clsx from "clsx";
import { FileCopy } from "@material-ui/icons";
import { Form, Formik, FormikHelpers } from "formik";
import * as yup from "yup";
import { MyTextField } from "../../custom/MyTextField";
import { AppState } from "../../../redux/reducers/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import { uiCloseModalAction } from "../../../redux/actions/uiActions";
import {
  IAppendDocs,
  ICorrespondence,
} from "../../../interfaces/Correspondence";
import { FC } from "react";
import { IAppendDocsSend } from "../../../redux/types/types";
import { firebase } from "../../../config/firebase/firebase-config";
import {
  CorrespondenceInputType,
  SUPPORTED_FORMATS_FILE,
} from "../../../enums/enums";
import { getCorrespondenceSection } from "../../../services/firebase/correspondence";
import ValidationForm from "../../../utils/uploadFile/form/ValidationForm";
import { fileHandleSelect } from "../../../utils/uploadFile/FileValidation";
import { addAttachedDocumentCorrespondence } from "../../../utils/uploadFile/service/uploadFileToFireBase";
import { IFileValidation } from "../../../utils/uploadFile/interfaces/IFileValidation";
import { IClassificaitionTrd } from "../../../module/documentManagment/doc/IClassificaitionTrd";
interface props {
  correspondence?: ICorrespondence;
  expedient?: IFuid;
  fromModule?: boolean;
}

export const UploadDocumentForm: FC<props> = ({
  correspondence,
  expedient,
  fromModule = false,
}) => {
  const [fileNames, setFileNames] = useState<IFiles>({
    fileName: "",
    url: "#",
  });

  const [validationData, setValidationData] = useState<IFileValidation>({
    noValid: false,
    noValidSize: false,
    noValidName: false,
    ok: false,
  });

  const [selected, setSelected] = useState({
    productionOffice: "",
    series: "",
    subseries: "",
    documentalType: "",
  });
  const { user } = useSelector((state: AppState) => state.auth);

  const dispatch = useDispatch();

  const intl = useIntl();
  const classes = useStyles();
  const {
    series: allSeries,
    latestProductionOffices,
    subSeries: allSubseries,
    documentalType: allDocumentalType,
    versions,
  } = useSelector((state: AppState) => state.trd);

  // select
  const [selectedProductionOffice, setSelectedProductionOffice] = useState({});

  const [series, setSeries] = useState(allSeries);
  const [selectedseries, setSelectedseries] = useState({});

  const [subSeries, setSubSeries] = useState(allSubseries);
  const [selectedsubSeries, setSelectedsubSeries] = useState({});

  const [documentalType, setDocumentalType] = useState(allDocumentalType);
  const [selecteddocumentalType, setSelecteddocumentalType] = useState({});

  const handleSelectFile = (e: any) => {
    const file = e.target.files[0] as File;
    const now = new Date().getTime().toString();

    if (file) {
      let validation = fileHandleSelect(file);
      setValidationData(validation);

      if (validation.ok) {
        return;
      }

      setFileNames({ url: "#", fileName: now + "_" + file.name, file });
    }
  };

  let now = new Date();
  now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
  const valueDate = now.toISOString().slice(0, 16);
  const initialValues = {
    attachedDocument: null,
    description: "",
    documentalType: "",
    uploadDate: valueDate,
  };

  const validationSchema = yup.object({
    description: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    uploadDate: yup
      .date()
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
  });

  const handleSelect = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    operation: any
  ) => {
    setSelected({ ...selected, [event.target.name]: event.target.value });

    switch (operation) {
      case "productionOffice":
        const selectedOfficeSearch = latestProductionOffices.find(
          (office) => office.idProductionOffice === event.target.value
        );
        if (selectedOfficeSearch) {
          setSelectedProductionOffice(selectedOfficeSearch);
        }
        break;
      case "serie":
        const selectedSerieSearch = series.find(
          (data) => data.idSerie === event.target.value
        );
        if (selectedSerieSearch) {
          setSelectedseries(selectedSerieSearch);
        }
        break;
      case "subserie":
        const subserieSearch = subSeries.find(
          (data) => data.idSubserie === event.target.value
        );

        if (subserieSearch) {
          setSelectedsubSeries(subserieSearch);
        }
        break;
      case "documenttype":
        const documentalTypeSearch = documentalType.find(
          (data) => data.idDocumentalType === event.target.value
        );
        if (documentalTypeSearch) {
          setSelecteddocumentalType(documentalTypeSearch);
        }
        break;
      default:
    }
  };

  const onClose = () => {
    dispatch(uiCloseModalAction());
  };

  useEffect(() => {
    //FILTRAR LOS SELECTS
    const seriesFiltered = allSeries.filter(
      (ser) => ser.idProductionOffice === selected.productionOffice
    );
    const subSeriesFiltered = allSubseries.filter(
      (subSer) => subSer.idSerie === selected.series
    );
    const documentalTypeFilter = allDocumentalType.filter(
      (docType) =>
        docType.idProductionOffice === selected.productionOffice &&
        docType.idSerie === selected.series &&
        docType.idSubSerie === selected.subseries
    );
    setSeries(seriesFiltered);
    setSubSeries(subSeriesFiltered);
    setDocumentalType(documentalTypeFilter);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  const handleSubmit = async (
    values: any,
    { setSubmitting }: FormikHelpers<any>
  ) => {
    setSubmitting(true);
    const trdVersion = versions.find((trd) =>
      trd.documentalType?.includes(selected.documentalType)
    );

    if (!fileNames.file || !user || !user.idEntity || !user.username) {
      setSubmitting(false);
      throw new Error("falta de información del usuario upload");
    }

    const lastAppendDocs = correspondence
      ? correspondence.appendDocs
      : expedient && expedient.documents;

    let objAppenDoc: IAppendDocs | IDocumentsFuid;
    let finalAppendDocs: IAppendDocs[] | IDocumentsFuid[];
    let objsAppendDocs: IAppendDocsSend | IDocsExpedientsSend;

    const file = fileNames.file;

    let trdCode: IClassificaitionTrd = {
      officeProduction: selectedProductionOffice,
      serie: selectedseries,
      subserie: selectedsubSeries,
      typeDocument: selecteddocumentalType,
      userId: user.id.toString(),
      createdAt: firebase.firestore.Timestamp.now(),
    };

    let trcoArray: IClassificaitionTrd[] = [];

    // Verificar si al menos un campo tiene información
    const hasData = Object.values(trdCode).some(
      (value) => value !== undefined && value !== null && value !== ""
    );

    if (hasData) {
      trcoArray.push(trdCode);
    }

    objAppenDoc = {
      url: fileNames.url,
      filename: fileNames.fileName,
      description: values.description,
      documentalType:
        selected.documentalType === "" ? null : selected.documentalType,
      officer: {
        id: user.id.toString(),
        name: user.username,
      },
      trdCode: trcoArray.length > 0 ? trcoArray : null,
      uploadDate: firebase.firestore.Timestamp.fromDate(
        new Date(values.uploadDate)
      ),
    };

    finalAppendDocs = lastAppendDocs
      ? [...lastAppendDocs, objAppenDoc]
      : [objAppenDoc];

    if (correspondence) {
      objsAppendDocs = {
        idCorrespondence: correspondence.id,
        appendDocs: finalAppendDocs as IAppendDocs[],
      };
      // VERIFICAR SI HAY EXPEDIENTES EN LA CORRESPONDENCIA
      if (
        correspondence &&
        correspondence.expedients &&
        correspondence.expedients.length >= 0
      ) {
        const isExpedient = true;
        const idExpedientCorrespondence = correspondence.expedients[0].id;
        await dispatch(
          addAttachedDocumentCorrespondence(
            objsAppendDocs,
            file,
            false,
            false,
            isExpedient,
            idExpedientCorrespondence
          )
        );
      } else {
        switch (correspondence.inputType) {
          case CorrespondenceInputType.IR:
            await dispatch(
              addAttachedDocumentCorrespondence(objsAppendDocs, file)
            );
            //repuera documento de ip
            var correspondenceIp = await getCorrespondenceSection(
              correspondence.idEntity,
              correspondence.correspondenceIpIr
            );

            objsAppendDocs = {
              idCorrespondence: correspondenceIp.id,
              appendDocs: finalAppendDocs as IAppendDocs[],
            };

            await dispatch(
              addAttachedDocumentCorrespondence(objsAppendDocs, file)
            );

            break;
          case CorrespondenceInputType.IP:
            await dispatch(
              addAttachedDocumentCorrespondence(objsAppendDocs, file)
            );
            //repuera documento de ip
            var correspondenceIr = await getCorrespondenceSection(
              correspondence.idEntity,
              correspondence.correspondenceIpIr
            );

            objsAppendDocs = {
              idCorrespondence: correspondenceIr.id,
              appendDocs: finalAppendDocs as IAppendDocs[],
            };

            await dispatch(
              addAttachedDocumentCorrespondence(objsAppendDocs, file)
            );

            break;
          default:
            await dispatch(
              addAttachedDocumentCorrespondence(objsAppendDocs, file)
            );
            break;
        }
      }
    } else if (expedient) {
      objsAppendDocs = {
        idExpedient: expedient.id,
        appendDocs: finalAppendDocs as IDocumentsFuid[],
      };

      await dispatch(
        addAttachedDocumentCorrespondence(
          objsAppendDocs,
          file,
          !!expedient,
          fromModule
        )
      );
    }

    setSubmitting(false);
  };

  return (
    <Formik
      validateOnChange={true}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => (
        <Form>
          <Grid container spacing={1}>
            <Grid item xs={12} style={{ marginBottom: 12 }}>
              <Box display="flex" justifyContent="space-between">
                <Box width={"35%"} mt={1}>
                  <label className="form-text">
                    <FormattedMessage id="AttachFile" />:
                  </label>
                </Box>

                <Box width={"45%"}>
                  <TextField
                    size="small"
                    type="file"
                    inputProps={{
                      accept: SUPPORTED_FORMATS_FILE.TYPE.join(","), // Convierte el array en un string separado por comas
                    }}
                    onChange={handleSelectFile}
                    id="icon-button-file"
                    autoComplete="off"
                    style={{ display: "none" }}
                  />

                  <TextField
                    size="small"
                    disabled={true}
                    variant="outlined"
                    style={{ color: "black" }}
                    name="file"
                    value={fileNames.fileName}
                    className={classes.myTextFieldRoot}
                  />
                </Box>

                <Box mt={1} width={"20%"}>
                  <Tooltip title={`${intl.formatMessage({ id: "Attach" })}`}>
                    <label htmlFor="icon-button-file">
                      <Button
                        className={clsx(classes.btnAction, classes.save)}
                        component="span"
                      >
                        <FileCopy /> <FormattedMessage id="Attach" />
                      </Button>
                    </label>
                  </Tooltip>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <ValidationForm validationData={validationData} />
            </Grid>

            <Grid item xs={12}>
              <label className="form-text">
                <FormattedMessage id="ContentDescription" />:
              </label>
              <MyTextField
                name="description"
                variant="outlined"
                className={classes.myTextFieldRoot}
                multiline
                rows={3}
                //disabled={details}
              />
            </Grid>
            <Grid item xs={12}>
              <label className="form-text">
                <FormattedMessage id="Date" />:
              </label>
              <Box width={"50%"}>
                <MyTextField
                  name="uploadDate"
                  variant="outlined"
                  type="datetime-local"
                  className={classes.myTextFieldRoot}
                />
              </Box>
            </Grid>
            <Grid item xs={12} style={{ marginTop: 12 }}>
              <label className="form-text">
                <FormattedMessage id="ClassificationAcordingTRD" />
              </label>
            </Grid>

            <Grid item xs={6}>
              <FormattedMessage id="ProductionOffice" />:
              <Box width={"100%"}>
                <TextField
                  name="productionOffice"
                  variant="outlined"
                  select
                  size="small"
                  value={selected.productionOffice}
                  className={classes.myTextFieldRoot}
                  onChange={(event) => handleSelect(event, "productionOffice")}
                  //   disabled={ active ? true : false}
                >
                  {latestProductionOffices.map((productionOffice) => (
                    <MenuItem
                      key={productionOffice.idProductionOffice}
                      value={productionOffice.idProductionOffice}
                    >
                      {productionOffice.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <FormattedMessage id="Series" />:
              <Box width={"100%"}>
                <TextField
                  name="series"
                  variant="outlined"
                  select
                  size="small"
                  value={selected.series}
                  className={classes.myTextFieldRoot}
                  onChange={(event) => handleSelect(event, "serie")}
                  //   disabled={ active ? true : false}
                >
                  {series.map((serie) => (
                    <MenuItem key={serie.idSerie} value={serie.idSerie}>
                      {serie.seriesName}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <FormattedMessage id="Subseries" />:
              <Box width={"100%"}>
                <TextField
                  name="subseries"
                  variant="outlined"
                  select
                  size="small"
                  value={selected.subseries}
                  className={classes.myTextFieldRoot}
                  onChange={(event) => handleSelect(event, "subserie")}
                  //   disabled={ active ? true : false}
                >
                  {subSeries.map((subSer) => (
                    <MenuItem key={subSer.idSubserie} value={subSer.idSubserie}>
                      {subSer.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <FormattedMessage id="DocumentaryType" />:
              <Box width={"100%"}>
                <TextField
                  name="documentalType"
                  variant="outlined"
                  select
                  size="small"
                  value={selected.documentalType}
                  className={classes.myTextFieldRoot}
                  onChange={(event) => handleSelect(event, "documenttype")}
                  //   disabled={ active ? true : false}
                >
                  {documentalType.map((doc) => (
                    <MenuItem
                      key={doc.idDocumentalType}
                      value={doc.idDocumentalType}
                    >
                      {doc.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </Grid>

            <Box mt={2} display="flex" flexDirection="row-reverse" width={1}>
              {!isSubmitting ? (
                <Button
                  className={clsx(classes.btn, classes.save)}
                  autoFocus
                  type="submit"
                  disabled={isSubmitting}
                >
                  <FormattedMessage id="Save" />
                </Button>
              ) : (
                <Button
                  className={clsx(classes.btn, classes.save)}
                  autoFocus
                  type="button"
                  disabled={true}
                >
                  <CircularProgress className={classes.btnLoading} />
                </Button>
              )}
              <Button
                className={clsx(classes.btn, classes.cancel)}
                onClick={onClose}
              >
                <FormattedMessage id="Cancel" />
              </Button>
            </Box>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};
